import React, { useEffect } from 'react';

import { Home } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getItems } from './operations';
import { Breadcrumbs, SubHeader, Footer, StandardDocumentsTable } from '../../../../components';
import './styles.scoped.css';

const StandardDocuments = () => {
  const navigation = useNavigate();
  const { listData } = useSelector(state => state.standardDocuments);

  useEffect(() => {
    getItems();
  }, []);

  return (
    <>
      <SubHeader
        text="Centerline Driver Qualification"
        buttons={[
          {
            icon: <Home sx={{ color: '#fff', fontSize: 30 }} />,
            onPress: () => navigation('/driver-qualification', { replace: true }),
          },
        ]}
      />
      <Breadcrumbs leftTitle="DQF Home" middleTitle="Standard Documents" route="/driver-qualification" />
      <div className="wrap">
        <p className="title">Standard Documents</p>
        <StandardDocumentsTable data={listData} />
      </div>
      <Footer />
    </>
  );
};
export default StandardDocuments;
